import TheFooter from "@/components/TheFooter";
import { FC } from "react";
import BaseLayout, { LayoutProps } from "./BaseLayout";

const NoHeaderLayout: FC<LayoutProps> = ({ children }): JSX.Element => {
  return (
    <BaseLayout requiredAuth={false}>
      <div>
        <div>
          <div className="min-h-screen">{children}</div>
          <TheFooter />
        </div>
      </div>
    </BaseLayout>
  );
};

export default NoHeaderLayout;
